import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { ROLLUP_VIEW_TYPES } from '../../../../store/rollups/rollups.interface';
import { getRollupViewType } from '../../../../store/rollups/rollups.selectors';
import { RollupsGCLineItemsSidebarComponent } from '@app/pages/webapp/rollups/rollups-interaction-bar/rollups-gcline-items-sidebar/rollups-gcline-items-sidebar.component';
import { RollupsManagerSidebarComponent } from '@app/pages/webapp/rollups/rollups-interaction-bar/rollups-manager-sidebar/rollups-manager-sidebar.component';
import { CurrentUserService } from '@app/services/current-user.service';

@Component({
  selector: 'app-rollups-interaction-bar',
  templateUrl: './rollups-interaction-bar.component.html',
  styleUrls: ['./rollups-interaction-bar.component.scss'],
  imports: [RollupsGCLineItemsSidebarComponent, RollupsManagerSidebarComponent],
})
export class RollupsInteractionBarComponent {
  private store = inject(Store);
  userService = inject(CurrentUserService);

  viewType = toSignal(this.store.select(getRollupViewType));
  protected readonly ROLLUP_VIEW_TYPES = ROLLUP_VIEW_TYPES;
}
